module.exports = Array.isArray;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@stamp/is/array.js
// module id = 93
// module chunks = 0